import HeroSection from "../components/home/HeroSection";
import VenueInfo from "../components/home/VenueInfo";
import Schedule from "../components/home/Schedule";
import FAQSection from "../components/home/FAQSection";
import HomeFooter from "../components/home/HomeFooter";
import { GroomModeProvider } from "../context/GroomModeContext";

export default function HomePage() {
  return (
    <GroomModeProvider>
      <main className="home-page">
        <HeroSection />
        <VenueInfo />
        <Schedule />
        <FAQSection />
        <HomeFooter />
      </main>
    </GroomModeProvider>
  );
}
